import { useState, useEffect } from 'react';

const YAML_URL = 'https://releases.darkplanner.com.br/latest-mac.yml';
const BASE_URL = 'https://releases.darkplanner.com.br';
const FALLBACK_VERSION = '0.3.0';
const FALLBACK_ARM64 = `${BASE_URL}/DarkPlanner-0.3.0-arm64.dmg`;
const FALLBACK_X64 = `${BASE_URL}/DarkPlanner-0.3.0-x64.dmg`;

export function useMacReleaseInfo() {
  const [info, setInfo] = useState({
    version: FALLBACK_VERSION,
    arm64Url: FALLBACK_ARM64,
    x64Url: FALLBACK_X64,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    fetch(YAML_URL, { signal: controller.signal })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((text) => {
        const versionMatch = text.match(/^version:\s*(.+)$/m);
        const arm64Match = text.match(/url:\s*(DarkPlanner-[\d.]+-arm64\.dmg)/);
        const x64Match = text.match(/url:\s*(DarkPlanner-[\d.]+-x64\.dmg)/);

        const version = versionMatch?.[1]?.trim() || FALLBACK_VERSION;
        const arm64Filename = arm64Match?.[1] || `DarkPlanner-${version}-arm64.dmg`;
        const x64Filename = x64Match?.[1] || `DarkPlanner-${version}-x64.dmg`;

        setInfo({
          version,
          arm64Url: `${BASE_URL}/${arm64Filename}`,
          x64Url: `${BASE_URL}/${x64Filename}`,
          loading: false,
          error: null,
        });
      })
      .catch((err) => {
        console.warn('[DarkPlannerApp] Fallback para versão hardcoded:', err.message);
        setInfo({
          version: FALLBACK_VERSION,
          arm64Url: FALLBACK_ARM64,
          x64Url: FALLBACK_X64,
          loading: false,
          error: err.message,
        });
      })
      .finally(() => clearTimeout(timeoutId));

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, []);

  return info;
}
